import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ContextMembership, DistrictReporting, FirestoreUser, NetworkConstants, Outline, HuntingDistrict} from 'diwimamodelweb/lib';
import { BehaviorSubject, Observable, Subject, Subscription, combineLatest, from } from 'rxjs';
import { SettingsService } from './settings.service';
import { deepCopy, diffObject, updatesToFirestoreUpdates } from 'diwimamodelweb/lib/utils/obejct-diff';
import { UserService } from './user.service';
import { TransactionLogService } from './transaction-log.service';
import {  map, take, takeUntil } from 'rxjs/operators';
import { removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { applySharingFieldDeletes } from './context-rights-picker/sharing-fields';
// import { deleteField } from 'firebase/firestore';
import { inject } from '@angular/core';
import { Firestore, collection, deleteDoc, doc, setDoc, docData, updateDoc, collectionGroup, collectionData, where, deleteField, query, getDocs, getDoc, or } from '@angular/fire/firestore';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HuntingDistrictService {
  private Ifirestore = inject(Firestore);

  ngUnsubscribe: Subject<void> = new Subject<void>();
  subscriptions: Map<string, Subscription> = new Map([])

  huntindDistrictSubject$ = new BehaviorSubject<HuntingDistrict[]>(undefined)
  subbdedContext: string|undefined = undefined

  allAuthoritiesVeterinary$ = new BehaviorSubject<any[]>(undefined)
  allHuntAuthorities = []
  allVetAuthorities = []
  allHuntAuthoritiesById = {}
  allVetAuthoritiesById = {}
  allAuthoritiesHunting$ = new BehaviorSubject<any[]>(undefined)
  allCountries$ = new BehaviorSubject<any[]>(undefined)
  allStates$ = new BehaviorSubject<any[]>(undefined)
  allUsers$ = new BehaviorSubject<any[]>(undefined)
  allUsersList = []
  allUsersListById = []

  reportingHuntingdistrict$:any[]

  private subbedMode: 'plain' | 'hierarchical' | undefined = undefined;

  constructor(
    private firestore: AngularFirestore,
    private settingsService: SettingsService,
    private userService: UserService,
    private transactionLogService: TransactionLogService,
    private http: HttpClient
  ) {
    combineLatest([
        this.settingsService.selectedUserContext$,
        this.settingsService.superContext,
        this.settingsService.subContext,
    ]).subscribe(([context, superContext, subContext]) => {
      this.observeData(context, superContext, subContext)
    });

    this.settingsService.selectedContextAndSubContextIds.subscribe( value => {
      this.observeData(this.settingsService.selectedUserContext$.value, this.settingsService.superContext.value, this.settingsService.subContext.value)
    })
  }

  observeData(context, superContext, subContext) {
    const ctxId = context?.identifier
    const subIds = this.settingsService.getSubcontextIds() //?? ((context as any).subContextIds ?? [])
    const ids = this.settingsService.selectedContextAndSubContextIds.value
    
    // console.log( '---- observeData() HD ----', context?.identifier, subIds, this.subbdedContext, ids)
    
    if (!context) {
      this.subbdedContext = undefined;
      this.subbedMode = undefined;
      return;
    }

    const hierarchical = !!(superContext || subContext);
    const dataFromIds = hierarchical ? (ids ? ids?.join(',') : ctxId) : ctxId
    const mode: 'plain' | 'hierarchical' = hierarchical ? 'hierarchical' : 'plain';

    if (dataFromIds === this.subbdedContext && mode === this.subbedMode) return;

    if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe();
    if (this.huntindDistrictSubject$.value) this.huntindDistrictSubject$.next(undefined);

    const sub = hierarchical
      ? this.observeDistrictsContextAndContextIds(
          ctxId,
          subIds,
          context,
        )
      : this.observeDistricts(ctxId);


    this.subscriptions.set('1', sub);
    this.subbdedContext = hierarchical ? (ids ? ids?.join(',') : ctxId) : ctxId
    this.subbedMode = mode;
  }

  getVeterinaryAuthorityList(): Promise<any>{
    let allAuth = []
    return new Promise(async (resolve, reject) => {
      try {
        this.allVetAuthoritiesById = {}
        // const va = this.firestore.collection(NetworkConstants.COLLECTION_GLOBAL_SETTINGS).doc(NetworkConstants.COLLECTION_VETERINARY_AUTHORITY).collection(NetworkConstants.COLLECTION_DATA).get()

        const path = `${NetworkConstants.COLLECTION_GLOBAL_SETTINGS}/${NetworkConstants.COLLECTION_VETERINARY_AUTHORITY}/${NetworkConstants.COLLECTION_DATA}`
        const collRef = collection(this.Ifirestore, path);

        await getDocs(collRef)
        .then(querySnapshot=> {
          querySnapshot.docs.forEach( (doc) => {
            const data = doc.data()
            data.id = doc.id
            this.allVetAuthoritiesById[data.id] = data
            allAuth.push(data)
            allAuth.sort((a,b) => a?.shortName?.localeCompare(b.shortName));
          })
        })

        this.allAuthoritiesVeterinary$.next(allAuth)

        resolve(allAuth)
      } catch (error) {
        reject(error) 
      }
    })
  }

  getCountriesList(): Promise<any>{
    return new Promise(async (resolve, reject) => {
      try {
        var list: any[] = []

        const path = `${NetworkConstants.COLLECTION_GLOBAL_SETTINGS}/${NetworkConstants.COLLECTION_COUNTRIES}/${NetworkConstants.COLLECTION_DATA}`
        const collRef = collection(this.Ifirestore, path);

        await getDocs(collRef)
        .then(querySnapshot=> {
          querySnapshot.docs.forEach( (doc) => {
            const data = doc.data()
            data.id = doc.id
            data.translate = 'countries.' + data.isoCode
            list.push(data)
            list.sort((a,b) => a?.name?.localeCompare(b.name));
          })
        })

        this.allCountries$.next(list)

        resolve(list)
      } catch (error) {
        reject(error) 
      }
    })
  }

  getStatesList(): Promise<any>{
    return new Promise(async (resolve, reject) => {
      try {
        var list: any[] = []

        const path = `${NetworkConstants.COLLECTION_GLOBAL_SETTINGS}/${NetworkConstants.COLLECTION_STATES}/${NetworkConstants.COLLECTION_DATA}`
        const collRef = collection(this.Ifirestore, path);

        await getDocs(collRef)
        .then(querySnapshot=> {
          querySnapshot.docs.forEach( (doc) => {
            const data = doc.data()
            data.id = doc.id
            data.translate = 'state.' + data.shortId

            list.push(data)
            list.sort((a,b) => a?.name?.localeCompare(b.name));
          })
        })
        this.allStates$.next(list)
        resolve(list)
      } catch (error) {
        reject(error) 
      }
    })
  }

  getHuntingAuthorityList(): Promise<any>{
    let allHunAuth = []
    return new Promise(async (resolve, reject) => {
      try {
        this.allHuntAuthoritiesById = {} 
        // const va = this.firestore.collection(NetworkConstants.COLLECTION_GLOBAL_SETTINGS).doc(NetworkConstants.COLLECTION_HUNTING_AUTHORITY).collection(NetworkConstants.COLLECTION_DATA).get()
        const path = `${NetworkConstants.COLLECTION_GLOBAL_SETTINGS}/${NetworkConstants.COLLECTION_HUNTING_AUTHORITY}/${NetworkConstants.COLLECTION_DATA}`
        const collRef = collection(this.Ifirestore, path);

        await getDocs(collRef)
        .then(querySnapshot=> {
          querySnapshot.docs.forEach( (doc) => {
            const data = doc.data()
            data.id = doc.id
            this.allHuntAuthoritiesById[data.id] = data
            allHunAuth.push(data)
            allHunAuth.sort((a,b) => a.shortName.localeCompare(b.shortName));
          })
        })

        this.allAuthoritiesHunting$.next(allHunAuth)
        resolve(allHunAuth)
      } catch (error) {
        reject(error) 
      }
    })
  }

  getUsersyList(contextId, objectId): Promise<any>{
    let allUsers = []
    this.allUsersList = []

    this.allUsers$.next(this.allUsersList)
    // this.getContextMembershipUsers(contextId)
    return new Promise(async (resolve, reject) => {
      try {
        const collRef = collection(this.Ifirestore, objectId);
        // const q = query(collRef, where('contextId', '==', contextId) );
        const q = query(collRef,
          or(where('contextId', '==', contextId),
             where('contextIds', 'array-contains', contextId)
          )
        );
        const snapshot =  await getDocs(q)

        snapshot.docs.forEach(doc=> {
          const user = doc.data()
          if(!user.identifier)
          user.identifier = doc.id

          if(user?.contextId === contextId || (user?.contextIds ? user.contextIds.includes(contextId) : false) || (user?.contextMembership ? Object.keys(user.contextMembership)?.includes(contextId) : false)){
            let us = new FirestoreUser
            us.setFromAny(user)
            const data = { 
              userId : us.identifier,
              userName: us.displayName
            }
            allUsers.push(user)

            this.allUsersList.push(us)
            this.allUsersListById[us.identifier] = data
          }            
        })
        this.allUsers$.next(this.allUsersList)
        this.getContextMembershipUsers(contextId) // for backward comp: keep looking inside COLLECTION_CONTEXT_MEMBERSHIP 
                
        resolve(allUsers)
      } catch (error) {
        reject(error) 
      }
    })
  }

  getContextMembershipUsers(contextId){
    const collRef = collectionGroup(this.Ifirestore, `${NetworkConstants.COLLECTION_CONTEXT_MEMBERSHIP}`);
    const q = query(collRef, where('identifier', '==', contextId));

    getDocs(q).then( value => {
      if(!value.docs) return
      else{
        value.docs?.forEach( doc => {
          const contextMembership:any = doc.data()

          const exists = this.allUsersList.filter(user=> contextMembership.userId === user.identifier)
          // for backward comp: if its not on the list collected from user.contexMembership
          if(exists?.length == 0){
            this.loadDocumentData(NetworkConstants.COLLECTION_USER, contextMembership.userId).subscribe(value => {
              if (!value) return
              let user = new FirestoreUser
              if(!value.identifier)
                value.identifier = contextMembership.userId

              user.setFromAny(value)
              const data  = {  userId : user.identifier, userName: user.displayName }

              this.allUsersList.push(user)
              this.allUsersListById[user.identifier] = data
              this.allUsers$.next(this.allUsersList)
            })
          }
          
        })
      }
    })
  }

  loadDocumentData(objectId: string, documentId: string): Observable<any|undefined> {
    // return this.firestore.collection(objectId).doc(documentId).get()    
    return from(getDoc(doc(this.Ifirestore, `${objectId}/${documentId}`))).pipe(
      map(snapshot => (snapshot.exists() ? snapshot.data() : undefined))
    );
  }

  async removeSubs(): Promise<void> {
    this.ngUnsubscribe.next()
    this.subbdedContext = undefined
    this.subscriptions.forEach((value) => {
      value.unsubscribe()
    })
    this.resetData()
    return Promise.resolve()
  }

  resetData() {
    this.huntindDistrictSubject$.next(null)
  }

  observeDistricts(contextId: string) {
    const path = `${NetworkConstants.COLLECTION_HUNTING_DISTRICT}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('contextId', '==', contextId))

    return collectionData(q)
      .pipe( takeUntil(this.ngUnsubscribe) )
      .subscribe(async (districts: any[]) => {
        const list: HuntingDistrict[] = districts.map(el => {
          const district = new HuntingDistrict()
          district.setFromAny(el)
          return district
        })

        // Emit straight away so districts render without waiting on every outline.
        this.huntindDistrictSubject$.next(list)

        await Promise.all(list.map(d =>
          this.getOutlinesOfDistrict(d).catch(err =>
            console.error('Outlines failed for district', (d as any)?.identifier, err),
          ),
        ))

        // New array reference so the map's districtsCache ref-check rebuilds the GeoJSON.
        this.huntindDistrictSubject$.next([...list])
      })
  }

  observeDistrictsContextAndContextIds(contextId: string, contextIds: string[], context) {
    // console.log('--- observeDistrictsContextAndContextIds ---', contextId, contextIds)
    const collRef = collection(this.Ifirestore, NetworkConstants.COLLECTION_HUNTING_DISTRICT);
    const CHUNK_SIZE = 30;
    const qy$ = [];

    qy$.push(collectionData(query(collRef, where('contextId', '==', contextId)))); // fetch own only once
    qy$.push(collectionData(query(collRef, where('contextIds', 'array-contains', contextId))));

    if (contextIds?.length) {
      for (let i = 0; i < contextIds.length; i += CHUNK_SIZE) {
        const chunk = contextIds.slice(i, i + CHUNK_SIZE);
        qy$.push(collectionData(query(collRef, where('contextId', 'in', chunk))));
      }
    }

    return combineLatest(...qy$)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: async (results: any[][]) => {
          // Dedupe by identifier where present, but never drop a district that
          // doesn't have one — collectionData() omits the doc id unless idField is set.
          const byId = new Map<string, HuntingDistrict>();
          const unkeyed: HuntingDistrict[] = [];
          results.flat().forEach((el: any) => {
            const district = new HuntingDistrict();
            district.setFromAny(el);
            const id = (district as any)?.identifier ?? el?.identifier;
            if (id) byId.set(id, district); else unkeyed.push(district);
          });
          const list = [...byId.values(), ...unkeyed];

          // Emit straight away so districts render without waiting on every outline.
          this.huntindDistrictSubject$.next(list);

          await Promise.all(list.map(d =>
            this.getOutlinesOfDistrict(d).catch(err =>
              console.error('Outlines failed for district', (d as any)?.identifier, err),
            ),
          ));

          // New array reference so the map's districtsCache ref-check rebuilds the GeoJSON.
          this.huntindDistrictSubject$.next([...list]);
        },
        error: (err) => console.error('Firestore error:', err),
      });
  }

  updateHuntingDistrict(oldDistrict: HuntingDistrict, newDistrict: HuntingDistrict, hiTierActive: boolean): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldDistrict, newDistrict, {})
      // const map = updatesToFirestoreUpdates(updates)
      const map = deepCopy(updates)

      for (let [key, value] of Object.entries(map)) {
        const {newValue} = value as any
        map[key] = newValue ? newValue : deleteField()
    }
      map.hiTierActive = hiTierActive

      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newDistrict.identifier, NetworkConstants.COLLECTION_HUNTING_DISTRICT)
        map['updateTimestamp'] = new Date()
        applySharingFieldDeletes(map, oldDistrict as any, newDistrict as any)
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_HUNTING_DISTRICT, newDistrict.identifier)
        await updateDoc( docRef, map)
       // await this.firestore.collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT).doc(newDistrict.identifier).update(map)
        // if successfull save transactionlog..
        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  setHuntingDistrict(oldDistrict: HuntingDistrict, newDistrict: HuntingDistrict, hiTierActive: boolean): Promise<void> {
    return new Promise(async (resolve, reject) => {
      removeUndefined(newDistrict)
      const updates = diffObject(oldDistrict, newDistrict, {})
      // const map = updatesToFirestoreUpdates(updates)
      const map = deepCopy(updates)

      for (let [key, value] of Object.entries(map)) {
        const {newValue} = value as any
        map[key] = newValue ? newValue : undefined
      }
    //   map.hiTierActive = hiTierActive
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newDistrict.identifier, NetworkConstants.COLLECTION_HUNTING_DISTRICT)
        map['updateTimestamp'] = new Date()
        applySharingFieldDeletes(map, oldDistrict as any, newDistrict as any)
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_HUNTING_DISTRICT, newDistrict.identifier)
        await setDoc( docRef, map, {merge:true})

        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  async createDistrict(newDistrict: any, id?:string): Promise<void | string> {
    return new Promise(async (resolve, reject) => {
      // const docRef = this.firestore.collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT).doc().ref
        const docRef = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_HUNTING_DISTRICT))
      const now = new Date()
      newDistrict['identifier'] = docRef.id
      newDistrict['creationDate'] = now
      newDistrict['updateTimestamp'] = now
      try {
        const contextId = this.settingsService.selectedUserContext$.value.identifier
        if (!contextId) reject("No context id")
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const logItems = this.transactionLogService.createLog(user, newDistrict.identifier, NetworkConstants.COLLECTION_HUNTING_DISTRICT, newDistrict)
        newDistrict['contextId'] = contextId
        await setDoc(docRef,{...newDistrict} )
       // await this.firestore.collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT).doc(newDistrict.identifier).set({...newDistrict})
        await this.transactionLogService.saveTransactionLog(logItems)
        resolve(docRef.id)
      } catch (error) {
        reject(error)
      }
    })
  }


  async deleteDistrictHunting(districtHunting: HuntingDistrict): Promise<void>{
    return new Promise(async (resolve,reject ) =>{
      try{
        const huntingTodelete = deepCopy(districtHunting, districtHunting.replacerFn)
        const dataToDelete = removeUndefined(huntingTodelete)
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const transactionLogItem = this.transactionLogService.deleteDocumentLog(
          user,
          districtHunting.identifier,
          NetworkConstants.COLLECTION_HUNTING_DISTRICT,
          dataToDelete
        )
        const promiseArray = []
        promiseArray.push(
          this.transactionLogService.saveTransactionLog([transactionLogItem])
        )
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_HUNTING_DISTRICT, districtHunting.identifier)
        const delOperation = await deleteDoc( docRef)
        // const delOperation = this.firestore.collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT).doc(districtHunting.identifier).delete()
        promiseArray.push(delOperation)
        resolve()

      }catch(error){
        reject(error)
      }
    })

  }

  async deleteDistrictOutline(huntingDistrictId: string, outlineId: string): Promise<void> {
    try {
      // await this.firestore.collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT).doc(huntingDistrictId).collection(NetworkConstants.COLLECTION_OUTLINE).doc(outlineId).delete()
      const path = `${NetworkConstants.COLLECTION_HUNTING_DISTRICT}/${huntingDistrictId}/${NetworkConstants.COLLECTION_OUTLINE}/${outlineId}`
      const docRef = doc(this.Ifirestore, path )
      await deleteDoc( docRef)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  getOutlinesOfDistrict(district: HuntingDistrict): Promise<void> {
    return new Promise((resolve, reject) => {
      const path = `${NetworkConstants.COLLECTION_HUNTING_DISTRICT}/${district.identifier}/${NetworkConstants.COLLECTION_OUTLINE}`
      const collRef = collection(this.Ifirestore, path)
      let settled = false
      collectionData(collRef).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (outlines: Outline[]) => {
          if (outlines.length > 0) district.outlines = outlines
          if (!settled) { settled = true; resolve() }
        },
        error: (error) => {
          if (!settled) { settled = true; reject(error) }
        }
      })
    })
  }

  createOutline(district: HuntingDistrict, newOutline: Outline):Promise<void> {
    return new Promise(async (resolve, reject) => {
      // const docRef = this.firestore
      //   .collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT)
      //   .doc(district.identifier)
      //   .collection(NetworkConstants.COLLECTION_OUTLINE)
      //   .doc().ref
      const docRef = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_HUNTING_DISTRICT, district.identifier, NetworkConstants.COLLECTION_OUTLINE))
      const now = new Date()
      newOutline['identifier'] = docRef.id
      newOutline['contextId'] = district.contextId
      newOutline['huntingDistrictId'] = district.identifier
      newOutline['creationDate'] = now
      newOutline['updateTimestamp'] = now
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const logItems = this.transactionLogService.createLog(user, newOutline.identifier, NetworkConstants.COLLECTION_OUTLINE, newOutline)
        // await this.firestore
        //   .collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT)
        //   .doc(district.identifier)
        //   .collection(NetworkConstants.COLLECTION_OUTLINE)  
        //   .doc(newOutline.identifier)
        //   .set({...newOutline})
        await setDoc(docRef,{...newOutline} )

        //update huntingDistrict updateTimestamp
        const newHuntingDistrict = deepCopy(district, district.replacerFn)
        await this.updateHuntingDistrict(district, newHuntingDistrict, district.hiTierActive ? true : false)

        await this.transactionLogService.saveTransactionLog(logItems)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  updateOutline(district: HuntingDistrict, oldOutline: Outline, newOutline: Outline): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldOutline, newOutline, {})
      const map = updatesToFirestoreUpdates(updates)
      map['updateTimestamp'] = new Date()
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newOutline.identifier, NetworkConstants.COLLECTION_OUTLINE)
        // await this.firestore.collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT).doc(district.identifier).collection(NetworkConstants.COLLECTION_OUTLINE).doc(newOutline.identifier).update(map)
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_HUNTING_DISTRICT, district.identifier, NetworkConstants.COLLECTION_OUTLINE, newOutline.identifier)
        await updateDoc( docRef, map)

        //update huntingDistrict updateTimestamp
        const newHuntingDistrict = deepCopy(district, district.replacerFn)
        await this.updateHuntingDistrict(district, newHuntingDistrict, district.hiTierActive ? true : false)

        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }



  observeDistrictReportingOfDistrict(district: any, didentifier:any) {////???---not used
      
    // this.firestore.collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT).doc(district).collection(NetworkConstants.COLLECTION_DISTRICT_REPORTING)
    //   .valueChanges().pipe(takeUntil(this.ngUnsubscribe))
    //   .subscribe((dreporting: any[]) => {
    //     if (dreporting.length > 0) {
    //       if(dreporting[0].huntingDistrictId==district){
    //         this.reportingHuntingdistrict$=dreporting[0]
    //       }
    //       return dreporting[0]
    //     }
    //   })
    //   return this.reportingHuntingdistrict$

  }


  getDistrictReportingOfDistrict(district: any,didentifier:any): Promise<void> {///???---not used
    // this.observeOutlinesOfDistrict(district)
    return new Promise(async (resolve, reject) => {
    //   try {
    //     // await this.firestore.collection(NetworkConstants.COLLECTION_HUNTING_DISTRICT).doc(district).collection(NetworkConstants.COLLECTION_DISTRICT_REPORTING).get() 
    //     resolve()
    //   } catch (error) {
    //     reject(error) 
    //   }
    })
  }
  getReportinGhuntingDistrictValues():any{
    return this.reportingHuntingdistrict$
  }

  loadHuntingDistrictsFromVetAuthId(veterinaryAuthorityId:string){
    return new Promise((resolve, reject) => {
      if(veterinaryAuthorityId){
        const url = `${environment.apiURL}/huntingDistricts/${veterinaryAuthorityId}`
        let list = []
        this.http.get(url).subscribe({
          next: (response: any) => {
            const elements = response.result
            elements.forEach( el=>{
              list.push(el)
            })
            resolve(list);
          },
          error: (error) => {
            console.error(error);
            reject(error);
          }
        })
      }
    })

  }

  loadOtlineFromTemplateHD(vetId, templateId){
    return new Promise((resolve, reject) => {
      if(templateId && vetId){
        // https://diwima-de-test.web.app/v1/huntingDistrict/SspmvZENjfXv5TkvzVsO/K4Y7eo3SeNpy6rMF9LB2
        const url = `${environment.apiURL}/huntingDistrict/${vetId}/${templateId}`
        this.http.get(url).subscribe({
          next: (response: any) => {
            const element = response.result
            resolve(element);
          },
          error: (error) => {
            console.error(error);
            reject(error);
          }
        })
      }
    })
  }
}
